import { SvgIcon } from '@mui/material'
import React from 'react'

export const ButtonIcon: React.FC<{ IconClass: typeof SvgIcon, left?: boolean, small?: boolean }> = ({ IconClass, left = false, small = false }) => {
  return (
    <IconClass sx={{ fontSize: small ? 19 : 23, marginLeft: left ? 0 : '8px', marginRight: left ? '8px' : 0 }} />
  )
}
